var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyListNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 101,
    viewBox: "0 0 129 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121.708 2.06445H7.47922C6.07075 2.06445 4.72008 2.62406 3.72415 3.61999C2.72822 4.61593 2.16892 5.9666 2.16892 7.37506V81.5236C2.1556 82.2294 2.2829 82.9305 2.54381 83.5864C2.80473 84.2424 3.1936 84.8397 3.68807 85.3435C4.18254 85.8473 4.77278 86.2476 5.42372 86.5208C6.07465 86.7939 6.77331 86.9343 7.47922 86.9342H121.708C123.126 86.9079 124.476 86.3263 125.469 85.3144C126.462 84.3026 127.018 82.9414 127.018 81.5236V7.37506C127.018 5.9666 126.459 4.61593 125.463 3.61999C124.467 2.62406 123.116 2.06445 121.708 2.06445V2.06445Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0742 98.5582V88.0371",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1133 88.0371V98.5582",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0664 99.0586H79.1245",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8711 73.8086H117.699",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4883 73.8086H39.4422",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5588 77.8168C48.7724 77.8168 50.5668 76.0224 50.5668 73.8088C50.5668 71.5952 48.7724 69.8008 46.5588 69.8008C44.3452 69.8008 42.5508 71.5952 42.5508 73.8088C42.5508 76.0224 44.3452 77.8168 46.5588 77.8168Z",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.957 37.8693L62.8479 43.7602L72.6659 31.9785",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7992 14.9609L68.3062 17.6663L72.5146 16.2635L74.8192 20.0712L79.3282 20.1714L80.23 24.5802L84.3383 26.1834L83.7371 30.5922L87.0437 33.5982L84.9395 37.506L87.0437 41.4138L83.7371 44.4199L84.3383 48.7285L80.23 50.4319L79.3282 54.7405L74.8192 54.9409L72.5146 58.6483L68.3062 57.3457L64.7992 60.0511L61.2922 57.3457L57.0837 58.6483L54.6789 54.9409L50.2701 54.7405L49.3683 50.4319L45.2601 48.7285L45.8613 44.4199L42.5547 41.4138L44.6589 37.506L42.5547 33.5982L45.8613 30.5922L45.2601 26.1834L49.3683 24.5802L50.2701 20.1714L54.6789 20.0712L57.0837 16.2635L61.2922 17.6663L64.7992 14.9609Z",
    stroke: "white",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyListNone);
export default __webpack_public_path__ + "static/media/my-list-none.d2e8b0c273f952f66c1743a8ae1c5d2e.svg";
export { ForwardRef as ReactComponent };